// extracted by mini-css-extract-plugin
export default {"container":"titles-options_container__MLJ2j","item":"titles-options_item__zNJmc","text":"titles-options_text__7gu3K","line":"titles-options_line__VuyY6"};